
const initialState = {
  plans: [],
  credits: {},
  payments: [],
  selectedPlan: {},
  usageMetrics: { cost: 0, minutes: 0, costPerMinute: 0 },
  loading: false
}

export default function paymentReducer(state = initialState, {type, payload}) {
  switch (type) {
    case 'GET_PLANS':
      return { ...state, loading: true };

    case 'SET_PLANS':
      return { ...state, plans: payload, loading: false };

    case 'SET_CURRENT_PLAN':
      return { ...state, selectedPlan: payload };

    case 'SET_CREDIT_PACKAGES':
      return { ...state, credits: payload };

    case 'SET_PAYMENTS':
      return { ...state, payments: payload };

    case 'SET_USAGE_METRICS':
      return { ...state, usageMetrics: payload }

    default:
      return state;
  }
}